import { DetailField } from "../detail-field";
import { DetailSectionFields } from "../detail-section-fields";
import type { DetailFieldListProps } from "./types-detail-field-list";

/** Lista de campos rótulo + valor, já formatados pelo ViewModel de quem a usa. */
export function DetailFieldListView({ testId, variant, fields }: DetailFieldListProps) {
  return (
    <DetailSectionFields testId={testId} variant={variant}>
      {fields.map(({ label, value, startsRow, href, hint, testId: fieldTestId }) => (
        <DetailField
          key={fieldTestId ?? label}
          label={label}
          value={value}
          startsRow={startsRow}
          href={href}
          hint={hint}
          variant={variant}
          testId={fieldTestId}
        />
      ))}
    </DetailSectionFields>
  );
}
